module.exports = __webpack_public_path__ + "img/logo_large.eff3baa7.png";